import i18n from 'i18next';
import intervalPlural from 'i18next-intervalplural-postprocessor';
// import marked from 'marked';

// import es from '@webapp-next/locales/es.json';

// TODO: pre process / generate static files / lazy load translations variables
import en from '@webapp-next/locales/en-combined.js';
import enAU from '@webapp-next/locales/en-AU-combined.js';

import defaultTranslationKeys from './default-translation-keys';

// const FORMAT = {
//   BR: function i18nFormatBr() {
//     return '<br />';
//   },
//   STRONG: function i18nFormatStrong(value) {
//     return `\\\<strong>${value}</strong>`;
//   },
// };

// TODO: moved to /vnext/components/wa-i18n-markdown to not make the translation function slower
// const markdown = {
//   type: 'postProcessor',
//   name: 'markdown',
//   process: function(value, key, options, translator) {
//     if (options.markdown) {
//       // TODO: add this library to prevent HTML to break and malicious code https://www.npmjs.com/package/dompurify
//       return marked(value, { breaks: true, xhtml: true });
//     }
//
//     return value;
//   },
// };

export default async function createI18n() {
  if (window.i18NextPromise && (await window.i18NextPromise())) {
    return;
  }

  // set currentLanguage here to change language
  const currentLanguage = 'en';
  const supportedLanguages = ['en', 'en-AU'];
  const resources = { en, 'en-AU': enAU };

  return (
    i18n
      .use(intervalPlural)
      // .use(markdown)
      .init({
        lng: currentLanguage,
        supportedLngs: supportedLanguages,
        ns: ['common'],
        defaultNS: 'common',
        resources,
        fallbackLng: {
          default: ['en'],
        },
        interpolation: {
          escapeValue: false,
          defaultVariables: defaultTranslationKeys(),
          format: function(value, format, lng) {
            if (format === 'lowercase') {
              return value?.toLowerCase();
            }

            if (format === 'uppercase') {
              return value?.toUpperCase();
            }

            if (format === 'capitalize') {
              const strLower = value?.toLowerCase();
              return strLower?.charAt(0)?.toUpperCase() + strLower?.slice(1);
            }

            return value;
          },
        },
      })
  );
}

window.i18nInstance = i18n;
